export default {
    getPersonalDescription: state => state.personalDescription,
    getProfileCard: state => state.profileCard,
    getMainAnswers: state => state.mainAnswers,
    getRandomQuestions: state => state.randomQuestions,
    getRandomAnsweredQuestions: state => state.randomAnsweredQuestions

};